import { Center, Loader } from '@mantine/core';

export const Loading = () => (
  <Center style={{ width: 600, height: 400 }}>
    <Loader variant="dots" />
  </Center>
);
